export const formatCpfCnpjValue = (v) => {
  v = v?.replace(/\D/g, '');

  if (v?.length <= 11) {
    v = v?.replace(/(\d{3})(\d)/, '$1.$2');
    v = v?.replace(/(\d{3})(\d)/, '$1.$2');
    v = v?.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  } else {
    v = v?.replace(/^(\d{2})(\d)/, '$1.$2');
    v = v?.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    v = v?.replace(/\.(\d{3})(\d)/, '.$1/$2');
    v = v?.replace(/(\d{4})(\d)/, '$1-$2');
  }

  return v;
};

export const maskZipCode = (value) => {
  const cleanValue = value?.replace(/\D/g, '');
  return cleanValue?.slice(0, 8).replace(/(\d{5})(\d{3})/, '$1-$2');
};

export const formatValue = (input, selectedType) => {
  switch (selectedType) {
    case 'zip_code':
      return maskZipCode(input);
    default:
      return input;
  }
};
